import { api_url } from "../../utils/constants";
const axios = require('axios').default;

export const calculateDomesticServiceCost = (requestCriteria, serviceDate, startTime, endTime) => {
    return axios.post(api_url + "/public/CalculateDomesticServiceCost", {
            requestCriteria,
            serviceDate,
            startTime,
            endTime
        }, {
            headers: { "Content-Type": "application/json" }
        })
        .then(response => response.data)
        .catch(error => {
            console.error("Error calculating domestic service cost:", error);
            throw error;
    });
}